module.exports = __webpack_public_path__ + "static/media/BlockOutlined.b7db7264.svg";